import { render } from "./App.vue?vue&type=template&id=36665d56&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=36665d56&scoped=true&lang=css"

import exportComponent from "D:\\javascript\\storyticket-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36665d56"]])

export default __exports__